export type MovieType = '电影' | '电视剧' | '综艺';

export interface Movie {
  id: string;
  title: string;
  cover: string;
  year: number;
  region: string;
  type: MovieType;
  genres: string[];
  rating: number;
  duration: string;
  status: string;
  director: string;
  cast: string[];
  description: string;
  highlights: string;
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: 'chang-ye-jiang-jin',
    title: '长夜将尽',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20lone%20figure%20standing%20on%20a%20rain%20soaked%20city%20street%20at%20night%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20street%20light%20glow%2C%20moody%20dramatic%20lighting%2C%20stylized%20painterly%20illustration%2C%20no%20text%2C%20highly%20detailed%20composition&width=480&height=720&seq=movie-cover-01&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '电影',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.7,
    duration: '128分钟',
    status: '已完结',
    director: '陈国栋',
    cast: ['林砚舟', '苏晚棠', '周牧云', '何劲'],
    description:
      '一桩尘封十二年的旧案重新浮出水面，刑警队长方屿在追查真相的过程中，逐渐发现身边最信任的人竟与案件有着千丝万缕的联系。长夜漫漫，真相与谎言在城市的霓虹下交织成一片迷局。',
    highlights: '冷峻克制的镜头语言，层层反转的叙事结构，被誉为年度最硬核的国产犯罪悬疑片。',
    featured: true,
  },
  {
    id: 'xing-hai-yuan-zheng',
    title: '星海远征',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20poster%20artwork%20of%20a%20massive%20spaceship%20approaching%20a%20glowing%20ringed%20planet%2C%20deep%20blue%20cosmos%20with%20orange%20nebula%20glow%2C%20stylized%20cinematic%20illustration%2C%20dramatic%20scale%2C%20no%20text%2C%20highly%20detailed%20composition&width=480&height=720&seq=movie-cover-02&orientation=portrait',
    year: 2025,
    region: '美国',
    type: '电影',
    genres: ['科幻', '冒险', '剧情'],
    rating: 9.1,
    duration: '146分钟',
    status: '已完结',
    director: 'Elliot Grant',
    cast: ['Noah Bennett', 'Mia Caldwell', 'Liam Foster', 'Ava Sinclair'],
    description:
      '地球资源枯竭的百年之后，一支远征舰队肩负着人类最后的希望驶向未知星系。当飞船穿越虫洞抵达目标行星时，船员们发现这里远比想象中更加危险，也更加美丽。',
    highlights: '震撼的宇宙视效与宏大的世界观构建，配乐与画面高度融合，IMAX版本广受好评。',
    featured: true,
  },
  {
    id: 'wu-sheng-zhi-cheng',
    title: '无声之城',
    cover:
      'https://readdy.ai/api/search-image?query=Atmospheric%20thriller%20film%20poster%20artwork%20of%20an%20empty%20foggy%20urban%20skyline%20at%20dawn%2C%20muted%20slate%20blue%20palette%20with%20a%20single%20warm%20window%20light%2C%20stylized%20painterly%20illustration%2C%20eerie%20calm%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-03&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '电影',
    genres: ['悬疑', '剧情'],
    rating: 8.2,
    duration: '112分钟',
    status: '已完结',
    director: '许知远',
    cast: ['顾清和', '叶南舟', '温言'],
    description:
      '一座城市在某个清晨突然失去了所有声音，唯独建筑师沈知白能听见细微的回响。她循着这些声音，一步步走进城市记忆深处被刻意掩埋的秘密。',
    highlights: '大胆的声音设计实验，用沉默讲述喧嚣，被影评人称为“需要用心聆听的电影”。',
  },
  {
    id: 'wu-du-yi-yun',
    title: '雾都疑云',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20detective%20film%20poster%20artwork%20of%20a%20silhouette%20with%20a%20trench%20coat%20under%20a%20gas%20lamp%20in%20thick%20fog%2C%20deep%20teal%20and%20amber%20contrast%2C%20stylized%20illustration%2C%20mysterious%20mood%2C%20no%20text%2C%20highly%20detailed%20composition&width=480&height=720&seq=movie-cover-04&orientation=portrait',
    year: 2024,
    region: '英国',
    type: '电影',
    genres: ['悬疑', '犯罪'],
    rating: 8.5,
    duration: '121分钟',
    status: '已完结',
    director: 'Arthur Kingsley',
    cast: ['Oliver Hale', 'Charlotte Reed', 'Daniel Frost'],
    description:
      '一九二〇年代的伦敦，私家侦探维克多在浓雾弥漫的码头接到一桩寻人委托，却意外卷入一场牵涉政商两界的巨大阴谋。',
    highlights: '复古考究的美术置景，层层递进的推理节奏，古典悬疑爱好者的心头好。',
  },
  {
    id: 'shi-guang-xin-xiang',
    title: '时光信箱',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20film%20poster%20artwork%20of%20an%20old%20wooden%20mailbox%20in%20a%20sunlit%20countryside%20garden%2C%20soft%20amber%20and%20cream%20tones%2C%20stylized%20watercolor%20illustration%2C%20nostalgic%20gentle%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-05&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    type: '电影',
    genres: ['爱情', '奇幻', '剧情'],
    rating: 8.0,
    duration: '108分钟',
    status: '已完结',
    director: '苏映雪',
    cast: ['江晚吟', '陆时衍', '沈知秋'],
    description:
      '小镇邮局里有一只神秘的绿色信箱，投入其中的信件会寄往十年前的地址。女主播温软在整理外婆遗物时发现了它，也重新遇见了那个错过的人。',
    highlights: '细腻温柔的情感表达，跨越时空的浪漫设定，看哭了不少观众。',
  },
  {
    id: 'huang-ye-gu-lang',
    title: '荒野孤狼',
    cover:
      'https://readdy.ai/api/search-image?query=Rugged%20survival%20action%20film%20poster%20artwork%20of%20a%20lone%20rider%20crossing%20a%20vast%20desert%20canyon%20at%20sunset%2C%20burnt%20orange%20and%20dusty%20brown%20tones%2C%20stylized%20cinematic%20illustration%2C%20epic%20lonely%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-06&orientation=portrait',
    year: 2024,
    region: '美国',
    type: '电影',
    genres: ['动作', '冒险', '西部'],
    rating: 7.9,
    duration: '134分钟',
    status: '已完结',
    director: 'Marcus Reed',
    cast: ['Jack Monroe', 'Elena Vasquez', 'Cole Dawson'],
    description:
      '退役军医凯恩独自穿越边境荒漠，只为将一卷记录真相的胶片送到该去的地方。追兵在后，风暴在前，他只能向前。',
    highlights: '极简的台词与极致的环境压迫感，实景拍摄的荒漠追逐戏令人屏息。',
  },
  {
    id: 'yan-huo-ren-jian',
    title: '烟火人间',
    cover:
      'https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20series%20poster%20artwork%20of%20a%20busy%20night%20street%20food%20market%20with%20warm%20lanterns%2C%20cozy%20amber%20and%20deep%20blue%20evening%20tones%2C%20stylized%20illustration%2C%20lively%20tender%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-07&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '电视剧',
    genres: ['家庭', '剧情', '都市'],
    rating: 8.9,
    duration: '45分钟/集',
    status: '更新至32集',
    director: '周明轩',
    cast: ['宋砚青', '许安然', '梁晓山', '钱多多'],
    description:
      '老城区一条即将拆迁的美食街，串联起五户普通人家的悲欢离合。小面馆老板娘、修鞋匠、快递员、退休教师……每个人都在烟火气里认真生活。',
    highlights: '真实接地气的生活流叙事，群像塑造鲜活，被观众称为“深夜里最治愈的一碗面”。',
    featured: true,
  },
  {
    id: 'an-yong',
    title: '暗涌',
    cover:
      'https://readdy.ai/api/search-image?query=Tense%20corporate%20thriller%20series%20poster%20artwork%20of%20a%20sleek%20glass%20office%20tower%20reflected%20in%20dark%20water%2C%20deep%20navy%20and%20cool%20steel%20tones%2C%20stylized%20illustration%2C%20cold%20suspenseful%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-08&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '电视剧',
    genres: ['悬疑', '商战', '剧情'],
    rating: 8.6,
    duration: '42分钟/集',
    status: '更新至24集',
    director: '高维',
    cast: ['傅斯年', '黎清欢', '韩铮'],
    description:
      '一场看似普通的商业并购背后，隐藏着十年前的股权骗局。投行精英沈砚在调查中发现自己敬重的导师，正是当年事件的操盘手。',
    highlights: '节奏紧凑的金融商战，职场博弈与人性拷问交织，反转密集。',
  },
  {
    id: 'chunri-chichi',
    title: '春日迟迟',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20youth%20romance%20series%20poster%20artwork%20of%20two%20figures%20cycling%20under%20cherry%20blossom%20trees%2C%20pastel%20pink%20and%20fresh%20green%20tones%2C%20stylized%20watercolor%20illustration%2C%20airy%20sweet%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-09&orientation=portrait',
    year: 2024,
    region: '韩国',
    type: '电视剧',
    genres: ['爱情', '青春', '治愈'],
    rating: 8.4,
    duration: '60分钟/集',
    status: '全16集',
    director: 'Kim Ji-hoon',
    cast: ['Han Seo-yeon', 'Park Min-jae', 'Lee Ha-eun'],
    description:
      '转学生车秀雅在小镇的樱花季遇见了沉默的园艺少年。两个各自背负着伤痛的年轻人，用一整个春天学会与过去和解。',
    highlights: '画面唯美如油画，情感克制又细腻，是近几年口碑最好的治愈系韩剧之一。',
  },
  {
    id: 'da-song-feng-yun-lu',
    title: '大宋风云录',
    cover:
      'https://readdy.ai/api/search-image?query=Grand%20historical%20drama%20series%20poster%20artwork%20of%20ancient%20Chinese%20palace%20under%20stormy%20skies%20with%20banners%2C%20deep%20crimson%20and%20gold%20tones%20with%20navy%20blue%2C%20stylized%20illustration%2C%20epic%20solemn%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-10&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '电视剧',
    genres: ['历史', '古装', '剧情'],
    rating: 8.8,
    duration: '45分钟/集',
    status: '全48集',
    director: '郑怀古',
    cast: ['萧景琰', '沈墨白', '柳青川', '陆云峥'],
    description:
      '北宋末年，一场关于改革与守旧的朝堂博弈席卷天下。出身寒微的士子陆知白凭借过人的才学步入中枢，在风云变幻中坚守心中道义。',
    highlights: '考究的服化道与严谨的历史细节，权谋群像戏张力十足。',
  },
  {
    id: 'du-shi-bian-yuan',
    title: '都市边缘',
    cover:
      'https://readdy.ai/api/search-image?query=Gritty%20urban%20drama%20series%20poster%20artwork%20of%20neon%20lit%20alleyways%20in%20a%20modern%20city%20at%20night%2C%20cool%20blue%20with%20vivid%20orange%20neon%20accents%2C%20stylized%20illustration%2C%20lonely%20restless%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-11&orientation=portrait',
    year: 2023,
    region: '中国香港',
    type: '电视剧',
    genres: ['剧情', '犯罪', '都市'],
    rating: 8.1,
    duration: '45分钟/集',
    status: '全30集',
    director: '麦子豪',
    cast: ['陈子谦', '林静怡', '黄浩然'],
    description:
      '五个来自不同背景的年轻人，在这座拥挤的城市里各自挣扎求存。一次意外的相遇，让他们的命运紧紧缠在了一起。',
    highlights: '冷色调的城市影像，真实刻画都市青年的困顿与坚持。',
  },
  {
    id: 'yi-zhe-ren-xin',
    title: '医者仁心',
    cover:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%20artwork%20of%20a%20doctor%20in%20a%20bright%20hospital%20corridor%2C%20clean%20white%20and%20calm%20teal%20tones%20with%20warm%20light%2C%20stylized%20illustration%2C%20hopeful%20professional%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-12&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '电视剧',
    genres: ['职场', '剧情', '都市'],
    rating: 8.3,
    duration: '44分钟/集',
    status: '更新至28集',
    director: '吴明德',
    cast: ['季星辰', '安然', '周子涵'],
    description:
      '急诊科新主任江屿带着前沿理念回到阔别多年的医院，却要面对旧友的质疑、资源的短缺和一场突如其来的公共卫生事件。',
    highlights: '专业的医疗细节与温暖的人文关怀并重，真实呈现一线医护的日常。',
  },
  {
    id: 'ji-xian-tiao-zhan-ying',
    title: '极限挑战营',
    cover:
      'https://readdy.ai/api/search-image?query=Energetic%20reality%20show%20poster%20artwork%20of%20a%20climbing%20wall%20with%20cheering%20crowd%20and%20confetti%2C%20vibrant%20orange%20and%20deep%20blue%20tones%2C%20stylized%20illustration%2C%20high%20energy%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-13&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '综艺',
    genres: ['真人秀', '竞技'],
    rating: 8.2,
    duration: '90分钟/集',
    status: '更新至10期',
    director: '范一鸣',
    cast: ['顾亦扬', '杨小满', '白鹿鸣', '田悦'],
    description:
      '十位来自不同领域的嘉宾被投放到极限户外营地，通过体能、智慧与团队协作的多轮挑战，争夺最终的“极限王者”荣誉。',
    highlights: '赛制新颖、笑点与泪点齐飞，是当季热度最高的户外竞技真人秀。',
    featured: true,
  },
  {
    id: 'sheng-dong-ren-xin',
    title: '声动人心',
    cover:
      'https://readdy.ai/api/search-image?query=Music%20talent%20show%20poster%20artwork%20of%20a%20glowing%20vintage%20microphone%20on%20a%20stage%20with%20spotlights%2C%20deep%20violet%20blue%20and%20gold%20tones%2C%20stylized%20illustration%2C%20emotional%20dramatic%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-14&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '综艺',
    genres: ['音乐', '选秀'],
    rating: 8.5,
    duration: '100分钟/集',
    status: '全12期',
    director: '林知夏',
    cast: ['周予安', '苏芮', '沈川', '何叶'],
    description:
      '四位风格迥异的音乐导师带领各自战队，通过盲选、对战与终极舞台，寻找那个拥有最动人声音的素人歌手。',
    highlights: '舞台水准堪比演唱会，素人选手的真实故事直击人心。',
  },
  {
    id: 'chu-fang-qi-yu-ji',
    title: '厨房奇遇记',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cooking%20show%20poster%20artwork%20of%20a%20rustic%20kitchen%20counter%20with%20colorful%20fresh%20ingredients%20and%20steam%2C%20warm%20amber%20and%20fresh%20green%20tones%2C%20stylized%20illustration%2C%20cozy%20cheerful%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-15&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '综艺',
    genres: ['美食', '真人秀'],
    rating: 8.0,
    duration: '60分钟/集',
    status: '更新至8期',
    director: '柳欢',
    cast: ['大厨老赵', '美食家小鹿', '主持人安安'],
    description:
      '每期节目走进一座城市，由明星嘉宾与当地名厨组队，用当地时令食材完成一道道充满人情味的家常菜。',
    highlights: '美食与旅行结合，烟火气十足，看完立刻想下厨。',
  },
  {
    id: 'shan-hai-zhu-guang',
    title: '山海逐光',
    cover:
      'https://readdy.ai/api/search-image?query=Travel%20documentary%20show%20poster%20artwork%20of%20a%20backpacker%20on%20a%20mountain%20ridge%20overlooking%20a%20golden%20sea%20of%20clouds%2C%20warm%20sunrise%20orange%20and%20deep%20blue%20tones%2C%20stylized%20illustration%2C%20inspiring%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-16&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '综艺',
    genres: ['旅行', '纪实'],
    rating: 8.7,
    duration: '55分钟/集',
    status: '全10期',
    director: '程远行',
    cast: ['旅人阿野', '摄影师老周', '向导央金'],
    description:
      '一支三人小队沿着祖国西部的山脊线徒步前行，记录沿途最壮美的自然风光与最质朴的人文故事。',
    highlights: '画面每一帧都能当壁纸，旁白文案被网友反复摘抄。',
  },
  {
    id: 'shen-hai-mi-hang',
    title: '深海迷航',
    cover:
      'https://readdy.ai/api/search-image?query=Underwater%20adventure%20film%20poster%20artwork%20of%20a%20tiny%20submarine%20descending%20into%20a%20deep%20glowing%20trench%2C%20dark%20teal%20and%20cyan%20tones%20with%20orange%20bioluminescence%2C%20stylized%20illustration%2C%20mysterious%20awe%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-17&orientation=portrait',
    year: 2025,
    region: '美国',
    type: '电影',
    genres: ['科幻', '冒险', '灾难'],
    rating: 8.3,
    duration: '118分钟',
    status: '已完结',
    director: 'Ryan Cole',
    cast: ['Ethan Brooks', 'Sophia Lane', 'Marcus King'],
    description:
      '一支深海科考队乘坐新型潜水器下潜至马里亚纳海沟，却在下方的黑暗世界里遭遇了远超人类认知的未知生命。',
    highlights: '沉浸式的深海压迫感，视效与音效合力打造窒息式观影体验。',
  },
  {
    id: 'ni-guang-er-xing',
    title: '逆光而行',
    cover:
      'https://readdy.ai/api/search-image?query=Inspiring%20sports%20drama%20film%20poster%20artwork%20of%20a%20runner%20silhouette%20sprinting%20toward%20sunset%20light%2C%20warm%20orange%20backlight%20against%20deep%20blue%20dusk%2C%20stylized%20illustration%2C%20uplifting%20determined%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-18&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '电影',
    genres: ['剧情', '运动', '励志'],
    rating: 8.6,
    duration: '124分钟',
    status: '已完结',
    director: '贺远征',
    cast: ['方旭', '林晚', '教练老马'],
    description:
      '因伤退役的短跑运动员回到家乡小城，接手了一支濒临解散的中学田径队。他带着一群被忽视的少年，向省运会发起最后的冲刺。',
    highlights: '热血而不煽情，真实还原竞技体育的残酷与荣光。',
  },
  {
    id: 'sha-qiu-zhi-wai',
    title: '沙丘之外',
    cover:
      'https://readdy.ai/api/search-image?query=Desert%20epic%20film%20poster%20artwork%20of%20giant%20sand%20dunes%20under%20a%20huge%20twin%20moon%20sky%2C%20golden%20sand%20and%20deep%20indigo%20tones%2C%20stylized%20illustration%2C%20vast%20mythic%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-19&orientation=portrait',
    year: 2025,
    region: '美国',
    type: '电影',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.9,
    duration: '152分钟',
    status: '已完结',
    director: 'Denis Vane',
    cast: ['Caleb Stone', 'Nora Ellis', 'Silas Ward'],
    description:
      '在沙暴肆虐的荒漠星球上，流亡的贵族后裔必须赢得原住民的信任，才能带领两个族群逃离即将到来的灭顶之灾。',
    highlights: '史诗级的沙漠美学与宏大叙事，被赞为科幻电影的新标杆。',
  },
  {
    id: 'lan-se-bian-jing',
    title: '蓝色边境',
    cover:
      'https://readdy.ai/api/search-image?query=Coastal%20crime%20series%20poster%20artwork%20of%20a%20weathered%20pier%20stretching%20into%20a%20stormy%20sea%20at%20twilight%2C%20deep%20blue%20and%20storm%20grey%20tones%20with%20warm%20lamp%20glow%2C%20stylized%20illustration%2C%20tense%20lonely%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-20&orientation=portrait',
    year: 2024,
    region: '韩国',
    type: '电视剧',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 8.4,
    duration: '65分钟/集',
    status: '全12集',
    director: 'Park Sung-min',
    cast: ['Jang Woo-jin', 'Seo Ye-rim', 'Kang Tae-oh'],
    description:
      '海港小城接连发生离奇失踪案，刑警郑宇镇在调查中发现，所有线索都指向自己阔别多年的故乡渔村。',
    highlights: '冷冽的海港氛围，扎实的推理链条，韩式悬疑剧的又一力作。',
  },
  {
    id: 'xin-tiao-xin-hao',
    title: '心跳信号',
    cover:
      'https://readdy.ai/api/search-image?query=Sweet%20romantic%20comedy%20series%20poster%20artwork%20of%20two%20people%20sharing%20an%20umbrella%20on%20a%20rainy%20city%20street%2C%20soft%20coral%20pink%20and%20fresh%20blue%20tones%2C%20stylized%20illustration%2C%20playful%20warm%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-21&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '电视剧',
    genres: ['爱情', '都市', '喜剧'],
    rating: 8.1,
    duration: '43分钟/集',
    status: '更新至20集',
    director: '夏之遥',
    cast: ['顾南川', '温柔', '林小满'],
    description:
      '一位冷静理性的心内科医生，遇上一位感性冲动的绘本作家，两个生活习惯截然不同的人在同一栋公寓里开始了鸡飞狗跳的邻居生活。',
    highlights: '轻松治愈的都市爱情，台词金句频出，甜度刚刚好。',
  },
  {
    id: 'huan-qiu-xun-wei-ji',
    title: '环球寻味记',
    cover:
      'https://readdy.ai/api/search-image?query=Global%20food%20travel%20show%20poster%20artwork%20of%20a%20street%20food%20stall%20in%20a%20lively%20foreign%20market%20at%20dusk%2C%20warm%20amber%20lanterns%20and%20deep%20blue%20sky%2C%20stylized%20illustration%2C%20vibrant%20inviting%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-22&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    type: '综艺',
    genres: ['美食', '旅行'],
    rating: 8.6,
    duration: '50分钟/集',
    status: '全12期',
    director: '钟意',
    cast: ['主持人乐乐', '美食博主阿福'],
    description:
      '两位主持人走遍全球十二座城市，深入当地市集与小馆，寻找最地道的人间风味和背后的人情故事。',
    highlights: '视角温暖接地气，异国美食与本地生活交织，越看越饿。',
  },
  {
    id: 'nao-li-feng-bao',
    title: '脑力风暴',
    cover:
      'https://readdy.ai/api/search-image?query=Brainy%20quiz%20show%20poster%20artwork%20of%20a%20glowing%20lightbulb%20shaped%20maze%20on%20a%20dark%20stage%2C%20deep%20blue%20with%20vivid%20orange%20accents%2C%20stylized%20illustration%2C%20clever%20energetic%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-23&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    type: '综艺',
    genres: ['益智', '竞技'],
    rating: 8.2,
    duration: '75分钟/集',
    status: '更新至6期',
    director: '简明',
    cast: ['学霸队', '民间高手队', '主持人秦朗'],
    description:
      '来自顶尖学府与各行各业的脑力高手同台对决，通过逻辑、记忆、观察等多维度挑战，角逐年度最强大脑。',
    highlights: '烧脑题目设计巧妙，全民可以跟着一起解题，参与感极强。',
  },
  {
    id: 'gui-tu-lie-che',
    title: '归途列车',
    cover:
      'https://readdy.ai/api/search-image?query=Emotional%20drama%20film%20poster%20artwork%20of%20a%20night%20train%20window%20with%20warm%20lights%20and%20a%20thoughtful%20passenger%20reflection%2C%20warm%20amber%20and%20cool%20blue%20contrast%2C%20stylized%20illustration%2C%20melancholic%20tender%20mood%2C%20no%20text%2C%20highly%20detailed&width=480&height=720&seq=movie-cover-24&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    type: '电影',
    genres: ['剧情', '公路', '家庭'],
    rating: 8.8,
    duration: '116分钟',
    status: '已完结',
    director: '沈砚书',
    cast: ['老周', '小舟', '乘务长梅'],
    description:
      '一趟穿越三千公里的绿皮火车上，一位父亲带着十年未见的儿子踏上归乡之路。窗外风景更迭，父子间沉默的坚冰也一点点融化。',
    highlights: '克制而深情的父子叙事，一个关于和解与回家的温柔故事。',
  },
];